module Meevo.Plugins.SmartCenter {
    "use strict";

    export class MeevoSmartCenterEditor implements angular.IDirective {
        restrict = "E";

        templateUrl = "app/plugins/smartCenter/smartTileEditorTemplate.html";

        constructor(
            private $filter: angular.IFilterService,
            private $mdSidenav: any,
            private $rootScope: ng.IRootScopeService,
            private editorService: any) {
        }

        link: ng.IDirectiveLinkFn = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
           


        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter, $mdSidenav, $rootScope, editorService) => {
                return new MeevoSmartCenterEditor($filter, $mdSidenav, $rootScope, editorService);
            };

            directive.$inject = ["$filter", "$mdSidenav", "$rootScope", "AppointmentEditorService"];

            return directive;
        }
    }

    angular.module("meevo.plugins.smartCenter")
        .directive("meevoSmartCenterEditor", MeevoSmartCenterEditor.factory());
}